import {gql, TypedDocumentNode} from "@apollo/client";

export const GetCharacters = gql`
    query getCharacters {
        getCharacters {
            characterName
            characterId
        }
    }
`

export const GetCharactersById = gql`
    query getCharacterById($characterId: Int!) {
        getCharacterById(characterId: $characterId) {
            characterId
            characterName
            Adventure {
                adventureName
                adventureDescription
                adventureId
            }
        }
    }
`

export const GetCharacter4User = gql`
    query Query($userId: Int!, $adventureId: Int!) {
        getCharacters4User(userId: $userId, adventureId: $adventureId) {
            characterExp
            characterId
            characterLevel
            characterName
            User {
                userName
                userId
            }
            Subrace {
                subraceDescription
                subraceId
                subraceName
                subraceFeatures {
                    subraceFeatureId
                    subraceFeatureName
                    subraceFeatureDesc
                }
            }
            Race {
                raceId
                raceName
                raceDescription
                raceFeatures {
                    raceFeatureId
                    raceFeatureName
                    raceFeatureDesc
                }
            }
            character_to_class {
                level
                Class {
                    hitdie
                    classSpellCast
                    className
                    classDescription
                    classId
                    subclassLevel
                    Mana {
                        manaMaxSpells
                        manaMaxSpellLevel
                        manaLevel
                        manaId
                        manaCantrips
                        manaAmount
                    }
                    ClassFeature {
                        classFeatureName
                        classFeatureId
                        classFeatureDesc
                        onLevel

                    }
                }
                Subclass {
                    subClassSpellCast
                    subclassDescription
                    subclassId
                    subclassName
                    Mana {
                        manaAmount
                        manaCantrips
                        manaId
                        manaLevel
                        manaMaxSpells
                        manaMaxSpellLevel
                    }
                    SubclassFeature {
                        onLevel
                        subclassFeatureDesc
                        subclassFeatureId
                        subclassFeatureName
                    }
                }
            }
            CharacterSheet {
                spellSaveDc
                spellAttackModifier
                silver
                gold
                skill_to_characterSheet {
                    proficiencyAmount
                    value
                    skill_to_characterSheetId
                    Skill {
                        skillName
                        skillId
                    }
                }
                lifepoints
                currentHitpoints
                temporaryHitpoints
                currentMana
                languages
                language_to_characterSheet {
                    language_to_characterSheetId
                    Language {
                        languageName
                        languageId
                    }
                }
                initiative
                armorClass
                ability_to_characterSheet {
                    proficiencyAmount
                    value
                    ability_to_characterSheetId
                    Ability {
                        abilityId
                        abilityName
                    }
                }
                Spell {
                    isConcentration
                    isActive
                    spellListType {
                        spellListTypeId
                        spellListTypeName
                        Ability {
                            abilityId
                            abilityName
                        }
                    }
                    savingThrow {
                        abilityId
                        abilityName
                    }
                    spellComponents
                    spellCost
                    spellId
                    spellName
                    spellDuration
                    spellTarget
                    spellText
                    spellType
                }
                Note {
                    noteText
                    noteId
                    noteHeading
                }
                Item {
                    itemId
                    itemDescription
                    itemAmount
                }
                characterSheetId
            }
            Adventure {
                adventureId
            }
        }
    }
`

export const GetValues4CharacterCreation = gql`
    query getValues4CharacterCreation {
        getClasses {
            classSpellCast
            className
            classDescription
            classId
            subclassLevel
            Subclass {
                subclassName
                subclassId
                subclassDescription
            }
        }
        getRaces {
            raceName
            raceId
            raceDescription
            Subrace {
                subraceName
                subraceId
                subraceDescription
            }
        }
    }
`

export const GetValues4LevelUp = gql`
    query getValues4LevelUp {
        getClasses {
            classSpellCast
            className
            classDescription
            classId
            subclassLevel
            Subclass {
                subclassName
                subclassId
                subclassDescription
            }
        }
    }
`

export const GetSubclassesByClass = gql`
    query GetSubclassesByClass($classId: Int!) {
        getSubclassesByClass(classId: $classId) {
            subClassSpellCast
            subclassDescription
            subclassId
            subclassName
        }
    }
`

export const GetAbilities = gql`
    query GetAbilities {
        getAbilities {
            abilityId
            abilityName
        }
    }
`

type GetSpellListTypeQueryType = {
    getSpellListTypes: {
        spellListTypeName: string
        spellListTypeId: string
        Ability: {
            abilityId: string
            abilityName:  string
        }
    }[]
}

export const GetSpellListTypes: TypedDocumentNode<GetSpellListTypeQueryType, never> = gql`
    query GetSpellListTypes {
        getSpellListTypes {
            spellListTypeName
            spellListTypeId
            Ability {
                abilityId
                abilityName
            }
        }
    }
`